import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const getLedgerEntryReport = createAsyncThunk(
  "app/getLedgerEntry",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(
      `/api/report/ledger-entry/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const exportLedgerEntryReport = async ({ filters }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(`/api/download/ledger-entry/filter`, body, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};